module.exports = __webpack_public_path__ + "img/allottee2_7-8-2021.35392f75.jpg";